import { Layout } from "Layout";

import { SyncList } from "components/SyncPage/SyncList";

import { i18n } from "services/i18nService";

import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { USER_PRIVILEGE } from "appConstants";

export function SyncErrorList(props) {
  const { objectType } = props;

  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const allowList = hasPrivilegesOrIsAdmin(USER_PRIVILEGE.sync);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <SyncList objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
